import { useState } from "react";
import { EditRowActions, Input, Td, Text, Tr } from "@/components/ui";
import type { ClaveSat } from "@/lib/types";
import { useEditarClaveSat } from "../hooks/use-clave-sat-mutations";

/**
 * Fila con toggle entre lectura y edición inline. Solo `descripcion` es
 * editable · la clave (8 dígitos SAT) es inmutable porque es la PK.
 */
export function ClaveSatRow({ clave }: { clave: ClaveSat }) {
  const [editando, setEditando] = useState(false);
  const [descripcion, setDescripcion] = useState(clave.descripcion);

  const guardar = useEditarClaveSat({
    onEditado: () => setEditando(false),
  });

  const cancelar = () => {
    setDescripcion(clave.descripcion);
    setEditando(false);
  };

  if (!editando) {
    return (
      <Tr>
        <Td>
          <Text size="xs" ff="mono">
            {clave.clave}
          </Text>
        </Td>
        <Td>
          <Text size="sm">{clave.descripcion}</Text>
        </Td>
        <Td align="right">
          <EditRowActions mode="view" onEdit={() => setEditando(true)} />
        </Td>
      </Tr>
    );
  }

  return (
    <Tr className="bg-muted/50">
      <Td>
        <Text size="xs" ff="mono">
          {clave.clave}
        </Text>
      </Td>
      <Td>
        <Input size="xs" value={descripcion} onChange={(e) => setDescripcion(e.currentTarget.value)} autoFocus />
      </Td>
      <Td align="right">
        <EditRowActions
          mode="edit"
          saving={guardar.isPending}
          onCancel={cancelar}
          onSave={() => guardar.mutate({ clave: clave.clave, descripcion: descripcion.trim() })}
        />
      </Td>
    </Tr>
  );
}
